module.exports = __webpack_public_path__ + "img/puerto_rico.aa766b9.webp";